import { Menu, Stack, Button, Group, Text, useMantineTheme } from '@mantine/core';

import { useCallback, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { IconChevronDown } from '@tabler/icons-react';

import { CheckIcon } from '../../icons';
import { updateResourceAssistantState } from '../../redux/ResourceAssistantSlice';
import { selectResourceAssistantState } from '../../redux/store';

interface Props {
  disabled: boolean
}

const QueryResourcesSelector: React.FC<Props> = (props: Props) => {
  const { disabled } = props;
  const { colors, other: colorVars } = useMantineTheme();
  const [opened, setOpened] = useState(false);
  const dispatch = useDispatch();

  const { filterByProposal } = useSelector(selectResourceAssistantState);

  const handleEditFilterByProposal = useCallback((filterByProposal: boolean) => {
    dispatch(updateResourceAssistantState({
      filterByProposal
    }));
  }, []);

  const buttonCopy = filterByProposal ? 'Proposal resources' : 'All resources';

  return (
    <Menu
      position="top-start"
      offset={10}
      opened={opened}
      onChange={setOpened}
    >
      <Menu.Target>
        <Button
          size='compact-md'
          style={{ borderColor: colors.gray[3] }}
          radius={16}
          variant='outline'
          disabled={disabled}
          onClick={() => { setOpened((o) => !o); }}
        >
          <Group gap={4}>
            <Text fz='sm'>
              {buttonCopy}
            </Text>
            <IconChevronDown size={16} color={colorVars.primaryIconColor} />
          </Group>
        </Button>
      </Menu.Target>
      <Menu.Dropdown maw={300}>
        <Stack gap={0}>
          <Menu.Item
            onClick={() => { handleEditFilterByProposal(false); setOpened(false); }}
            leftSection={!filterByProposal && <CheckIcon />}
          >
            All resources
          </Menu.Item>
          <Menu.Item
            leftSection={filterByProposal && <CheckIcon />}
            onClick={() => { handleEditFilterByProposal(true); setOpened(false); }}
          >
            Proposal resources
          </Menu.Item>
        </Stack>
      </Menu.Dropdown>
    </Menu>
  );
};

export default QueryResourcesSelector;
